import i18n from "../../../public/i18n";
import CustomDashboardIcon from "../../app/assets/custom-icons/CustomDashboardIcon";
import CustomDocManagementIcon from "../../app/assets/custom-icons/CustomDocManagementIcon";
import GestisciPratichePage from "../../features/user/GestisciPratichePage/GestisciPratichePage";
import DashboardPage from "../../features/common/DashboardPage/DashboardPage";
import CaricaDocumentiPage from "../../features/user/CaricaDocumentiPage/CaricaDocumentiPage";
import FolderExpenseDoc from "../../features/user/GestioneDocumentiPage/Folders/FolderExpenseDoc";
import FolderMacrocat from "../../features/user/GestioneDocumentiPage/Folders/FolderMacrocat";
import GestioneDocumentiPage from "../../features/user/GestioneDocumentiPage/GestioneDocumentiPage";
import CustomPaperworkManagementIcon from "../../app/assets/custom-icons/CustomPaperworkManagementIcon";
import ChatPage from "../../features/common/ChatPage/ChatPage";
import CustomInbox from "../../app/assets/custom-icons/CustomInbox";
import ServiziStudioPage from "../../features/user/Servizi/ServiziStudioPage/ServiziStudioPage";
// import ServiziCompanyPage from "../../features/user/Servizi/ServiziCompanyPage/ServiziCompanyPage";
import CustomStudioServicesIcons from "../../app/assets/custom-icons/CustomStudioServicesIcons";
import NewsPage from "../../features/common/NewsPage/NewsPage";
import CustomNewsIcon from "../../app/assets/custom-icons/CustomNewsIcon";
import CalendarPage from "../../features/user/CalendarPage/CalendarPage";
import CustomCalendar from "../../app/assets/custom-icons/CustomCalendar";
import AssociaStudioPage from "../../features/user/AssociaStudioPage/AssociaStudioPage";
import AssociaStudioDettaglioPage from "../../features/user/AssociaStudioPage/AssociaStudioDettaglioPage/AssociaStudioDettaglioPage";
import SinglePraticaPage from "../../features/user/GestisciPratichePage/SinglePraticaPage/SinglePraticaPage";
import DocumentiPage from "../../features/user/GestisciPratichePage/SinglePraticaPage/DocumentiPage";
import { FormUserCompany } from "../../features/user/ModificaProfiloPage/FormUserCompany";
import Reservation from "../../features/common/Reservation/Reservation";
import ModificaProfiloPage from "../../features/user/ModificaProfiloPage/ModificaProfiloPage";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import MioStudioPage from "../../features/user/MioStudioPage/MioStudioPage";
import WorkRoundedIcon from "@mui/icons-material/WorkRounded";
import TerminiCondizioniPage from "../../features/common/TerminiCondizioniPage/TerminiCondizioniPage";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import AssistenzaPage from "../../features/user/AssistenzaPage/AssistenzaPage";
import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import PrivacyTipRoundedIcon from "@mui/icons-material/PrivacyTipRounded";
import NewsDetailPage from "../../features/common/NewsPage/NewsDetailPage";


export const routesUser = (appConfig) => [
  {
    name: "dashboard",
    path: i18n.t("dashboard"),
    label: i18n.t("Dashboard"),
    component: <DashboardPage />,
    icon: <CustomDashboardIcon className="w-10 h-10" />,
    capabilities: [], // Tutti possono accedere alla dashboard
    isSidebarElement: true,
    isTopbarElement: false,
    ai: false,
    order: appConfig?.sectionsOrderUser?.indexOf("dashboard"),
  },
  {
    name: "documents",
    path: i18n.t("documentManagement"),
    label: i18n.t("SmartArchive"),
    component: <GestioneDocumentiPage />,
    icon: <CustomDocManagementIcon className="w-10 h-10" />,
    capabilities: [],
    isSidebarElement: true,
    isTopbarElement: false,
    ai: true,
    order: appConfig?.sectionsOrderUser?.indexOf("documents"),
  },
  {
    path: i18n.t("uploadDocuments"),
    name: i18n.t("uploadDocuments"),
    label: i18n.t("UploadDoc"),
    component: <CaricaDocumentiPage />,
    capabilities: [],
    isSidebarElement: false,
    isTopbarElement: false,
  },
  {
    name: "folder-category",
    path: `${i18n.t("documentManagement")}/folder`,
    component: <FolderMacrocat />,
    capabilities: [],
    isSidebarElement: false,
    isTopbarElement: false,
  },
  {
    name: "folder-doc-list",
    path: `${i18n.t("documentManagement")}/folder/documenti`,
    component: <FolderExpenseDoc />,
    capabilities: [],
    isSidebarElement: false,
    isTopbarElement: false,
  },
  {
    name: "practices",
    path: i18n.t("managePractices"),
    label: i18n.t("Practice"),
    component: <GestisciPratichePage />,
    icon: <CustomPaperworkManagementIcon className="w-10 h-10" />,
    capabilities: [],
    isSidebarElement: true,
    isTopbarElement: false,
    ai: true,
    order: appConfig?.sectionsOrderUser?.indexOf("practices"),
  },
  {
    name: "chat",
    path: i18n.t("chat"),
    label: i18n.t("Chat"),
    component: <ChatPage />,
    icon: <CustomInbox className="w-10 h-10" />,
    capabilities: [],
    isSidebarElement: true,
    isTopbarElement: false,
    ai: true,
    order: appConfig?.sectionsOrderUser?.indexOf("chat"),
  },
  {
    name: "services",
    path: i18n.t("services"),
    label: i18n.t("Services"),
    component: <ServiziStudioPage />,
    icon: <CustomStudioServicesIcons className="w-10 h-10" />,
    capabilities: [],
    isSidebarElement: true,
    isTopbarElement: false,
    ai: true,
    order: appConfig?.sectionsOrderUser?.indexOf("services"),
  },
  {
    name: "news",
    path: i18n.t("news"),
    label: i18n.t("News"),
    component: <NewsPage />,
    icon: <CustomNewsIcon className="w-10 h-10" />,
    capabilities: [],
    isSidebarElement: true,
    isTopbarElement: false,
    order: appConfig?.sectionsOrderUser?.indexOf("news"),
  },
  {
    path: `${i18n.t("news")}/:id`,
    component: <NewsDetailPage />,
    capabilities: [],
    isSidebarElement: false,
    isTopbarElement: false,
  },
  {
    name: "deadlines",
    path: i18n.t("calendar"),
    label: i18n.t("Calendar"),
    component: <CalendarPage />,
    icon: <CustomCalendar className="w-10 h-10" />,
    capabilities: [],
    isSidebarElement: true,
    isTopbarElement: false,
    order: appConfig?.sectionsOrderUser?.indexOf("deadlines"),
  },

  {
    name: i18n.t("singlePracticeRoute"),
    path: `${i18n.t("singlePracticeRoute")}/:id`,
    component: <SinglePraticaPage />,
    capabilities: [],
    isSidebarElement: false,
    isTopbarElement: false,
  },
  {
    name: "documenti",
    path: `${i18n.t("singlePracticeRoute")}/:id/${i18n.t("documents")}`,
    component: <DocumentiPage />,
    capabilities: [],
    isSidebarElement: false,
    isTopbarElement: false,
  },
  {
    name: i18n.t("edit-company"),
    path: i18n.t("edit-company"),
    component: <FormUserCompany />,
    capabilities: [],
    isSidebarElement: false,
    isTopbarElement: false,
  },
  {
    name: i18n.t("reservation"),
    path: i18n.t("reservation"),
    component: <Reservation />,
    capabilities: [],
    isSidebarElement: false,
    isTopbarElement: false,
  },

  //TOP BAR ELEMENTS

  {
    name: i18n.t("profile"),
    path: i18n.t("profile"),
    label: i18n.t("Profile"),
    component: <ModificaProfiloPage />,
    icon: <PersonRoundedIcon />,
    capabilities: [],
    isSidebarElement: false,
    isTopbarElement: true,
  },
  {
    path: `associa-${i18n.t("studio")}`,
    component: <AssociaStudioPage />,
    capabilities: [],
    isSidebarElement: false,
    isTopbarElement: false,
  },
  {
    path: `associa-${i18n.t("studio")}/:id`,
    component: <AssociaStudioDettaglioPage />,
    capabilities: [],
    isSidebarElement: false,
    isTopbarElement: false,
  },
  {
    name: i18n.t("search-studio"),
    path: i18n.t("search-studio"),
    label: i18n.t("Search") + " " + i18n.t("extStudio"),
    component: <AssociaStudioPage />,
    icon: <SearchRoundedIcon />,
    capabilities: [],
    isSidebarElement: false,
    isTopbarElement: appConfig?.modules?.user?.searchStudio,
  },
  {
    name: i18n.t("myStudioRoute"),
    path: i18n.t("myStudioRoute"),
    label: i18n.t("MyStudio"),
    component: <MioStudioPage />,
    icon: <WorkRoundedIcon />,
    capabilities: [],
    isSidebarElement: false,
    isTopbarElement: true,
  },
  {
    name: "terms",
    path: i18n.t("terms-and-conditions"),
    label: i18n.t("TermsAndConditions"),
    component: <TerminiCondizioniPage />,
    icon: <ReceiptLongRoundedIcon />,
    capabilities: [],
    isSidebarElement: false,
    isTopbarElement: true,
  },
  {
    name: i18n.t("assistance"),
    path: i18n.t("assistance"),
    label: i18n.t("Assistance"),
    component: <AssistenzaPage />,
    icon: <HelpRoundedIcon />,
    capabilities: [],
    isSidebarElement: false,
    isTopbarElement: false,
  },
  {
    name: "privacy",
    path: "privacy",
    label: "Privacy policy",
    icon: <PrivacyTipRoundedIcon />,
    capabilities: [],
    isSidebarElement: false,
    isTopbarElement: true,
  },

];